/** Defaults for marketing send caps / IP warmup (env may override). */
export const MARKETING_SEND_LIMIT_DEFAULTS = {
  hourlyCapPerCreator: 200,
  dailyCapPerCreator: 2000,
  warmupDailyCap: 50,
} as const;

export type MarketingSendLimitConfig = {
  hourlyCapPerCreator: number;
  dailyCapPerCreator: number;
  warmupDailyCap: number;
};

export function loadMarketingSendLimitConfig(
  env: NodeJS.ProcessEnv = process.env,
): MarketingSendLimitConfig {
  return {
    hourlyCapPerCreator: Number(
      env.MARKETING_SEND_HOURLY_CAP_PER_CREATOR ??
        MARKETING_SEND_LIMIT_DEFAULTS.hourlyCapPerCreator,
    ),
    dailyCapPerCreator: Number(
      env.MARKETING_SEND_DAILY_CAP_PER_CREATOR ?? MARKETING_SEND_LIMIT_DEFAULTS.dailyCapPerCreator,
    ),
    warmupDailyCap: Number(
      env.MARKETING_WARMUP_DAILY_CAP ?? MARKETING_SEND_LIMIT_DEFAULTS.warmupDailyCap,
    ),
  };
}

export function resolveEffectiveDailyMarketingCap(input: {
  config: MarketingSendLimitConfig;
  warmupActive?: boolean;
}): number {
  if (input.warmupActive) {
    return Math.min(input.config.dailyCapPerCreator, input.config.warmupDailyCap);
  }
  return input.config.dailyCapPerCreator;
}

export function isMarketingSendWithinCaps(input: {
  sentLastHour: number;
  sentToday: number;
  config: MarketingSendLimitConfig;
  warmupActive?: boolean;
}): boolean {
  if (input.sentLastHour >= input.config.hourlyCapPerCreator) return false;
  const dailyCap = resolveEffectiveDailyMarketingCap({
    config: input.config,
    warmupActive: input.warmupActive,
  });
  return input.sentToday < dailyCap;
}

/** Env/runtime kill-switch for marketing submits (S02 stub). */
export function isMarketingSendKillSwitchEnabled(
  env: NodeJS.ProcessEnv = process.env,
): boolean {
  const raw = (env.MARKETING_SEND_KILL_SWITCH ?? '').trim().toLowerCase();
  return raw === '1' || raw === 'true' || raw === 'yes' || raw === 'on';
}
